var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "list-group-item" },
    [
      _c(
        "b-row",
        [
          _c(
            "div",
            { staticClass: "pl-3 pr-0 img" },
            [
              _c("b-skeleton", {
                staticClass: "mr-2",
                attrs: { type: "avatar", width: "2.85rem", height: "2.85rem" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "align-self-center comment-section" }, [
            _c(
              "h6",
              { staticClass: "text-dark-gray" },
              [_c("b-skeleton", { attrs: { width: "50%" } })],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "activity-options d-flex flex-column align-items-end",
              attrs: { cols: "12", xl: "4" },
            },
            [
              _c("b-skeleton", { attrs: { width: "30%" } }),
              _vm._v(" "),
              _c("b-skeleton", { attrs: { width: "50%" } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }